import StatusBadge from "../../Components/UI/statusBadge";
import TableActions from "../../Components/UI/table/TableActions";
import TransactionsStatusBadge from "../../Components/UI/transactionsstatusbadge";
import { formatPrice } from "../../utils/formatPrice";
import { deletePaymentMethod } from "../../MyApi/paymentmethods";
import TransactionsStatusBadgeType from "../../Components/UI/transactionsStatusBadgeType";
import { updateWithdrawal } from "../../MyApi/withdrawals";
import { useMutation, useQueryClient } from "react-query";
import { Spinner } from "reactstrap";

// ======================= Tabs =======================

export const tabs = [
  {
    key: "commissionSettings",
    label: "إعدادات العمولة",
    permission: "update_store",
  },
  {
    key: "paymentRequests",
    label: "طلبات الدفع",
    permission: "view_withdrawal",
  },
  {
    key: "transactions",
    label: "سجل المدفوعات",
    permission: "view_transaction",
  },
  {
    key: "paymentMethods",
    label: "طرق الدفع",
    permission: "view_payment_method",
  },
];

// ======================= Coupon Columns =======================   



export const commissionSettingsColumns = [
  {
    label: "معرف المتجر",
    render: (row) => <div className="text-green">{row.id}# </div>,
  },
  { label: "المتجر", accessor: "name" },
  { label: "نوع العمولة", accessor: "commission_type" },

  {
    label: "نسبة العمولة",
    render: (row) => (
      <div className="text-green">
        {row.commission_amount}{" "}
        {row.commission_type === "commission" ? "%" : ""}
      </div>
    ),
  },
  { label: "مجموع العمولة", accessor: "total_earned_commission" },
  { label: " الطلبات", accessor: "total_orders" },

  {
    label: "الحالة",
    render: (row) => (
      <StatusBadge
        status={row.status === "approved" ? "active" : "inActive"}
        statusLabel={row.status}
      />
    ),
  },
 
];

export const transactionsColumns = [
  { label: "معرف المعاملة ", accessor: "id" },
  {
    label: "المتجر",
    render: (row) => (
      <div>
        {" "}
        <h6>{row?.transactionable && row?.transactionable?.type} </h6>{" "}
        <p className="desc text-start">
          {row?.transactionable && row?.transactionable?.name} #{row?.transactionable  &&row?.transactionable?.id}
        </p>{" "}
      </div>
    ),
  },
  {
    label: "نوع المعاملة",
    render: (row) => (
      <div>
        {" "}
        <TransactionsStatusBadgeType status={row.type} />{" "}
      </div>
    ),
  },

  { label: "المبلغ", render: (row)=>(
    <div className={`${(row.type ==="increment" ||row.type ==="deposit") ?"text-green":"text-danger"}`}>{row.currency} {formatPrice(row.currency_factor ,row.amount)} {`${(row.type ==="increment" ||row.type ==="deposit") ?"+":"-"}`}</div>
    ) },
  { label: "طريقة الدفع", accessor: "payment_method" },
  { label: "تاريخ الطلب", accessor: "created_at" },
  {
    label: "الحالة",
    render: (row) => (
      <TransactionsStatusBadge status={row.status} statusLabel={row.status} />
    ),
  },
  {
    label: "الإجراءات",
    render: (row) => <TableActions show={`/coupons/${row.id}`} />,
  },
];
